import React from 'react';
import PropTypes from 'prop-types';

import { Audiencias } from '../../../../assets/images/index';

import {
  StyledLoadingContainer,
  StyledTitleWidget,
  WrapperFlex,
  WrapperModuleSearch
} from './style';

import Loading from '../../core/Loading';
import BoxInside from '../../core/BoxInside';

import { SearchByDate } from '../SearchByDate';

import ModulesWrapper from './modulesWrapper';
import { dataDailyShareModel } from '../../../utils/models';

const Audiences = ({
  onFilterDate,
  dataDailyShare,
  dataRanking,
  dataMonthlyShare,
  dataDailyReports,
  isLoading,
  isOnErrorLoadData,
  initialDate
}) => {
  const getRender = () => {
    if (isLoading) {
      return (
        <StyledLoadingContainer>
          <Loading size="xl" />
        </StyledLoadingContainer>
      );
    }
    if (isOnErrorLoadData) {
      return (
        <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
      );
    }
    return (
      <ModulesWrapper
        dataDailyShare={dataDailyShare}
        dataRanking={dataRanking}
        dataMonthlyShare={dataMonthlyShare}
        dataDailyReports={dataDailyReports}
        isOnErrorLoadData={isOnErrorLoadData}
      />
    );
  };

  return (
    <div className="department_container" style={{ backgroundColor: '#FFF' }}>
      <BoxInside>
        <StyledTitleWidget
          title="Audiencias"
          type="audiences"
          icon={Audiencias}
          small
        />
        <WrapperFlex>
          <WrapperModuleSearch>
            <SearchByDate
              day={initialDate.day}
              month={initialDate.month}
              weekday={initialDate.weekday}
              fullDay={dataDailyShare}
              isAudiences
              onClick={onFilterDate}
            />
          </WrapperModuleSearch>
          {getRender()}
        </WrapperFlex>
      </BoxInside>
    </div>
  );
};

Audiences.propTypes = {
  dataDailyShare: dataDailyShareModel,
  dataRanking: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      cadena: PropTypes.string,
      emision: PropTypes.string,
      miles: PropTypes.number,
      indiceTelevisivo: PropTypes.number
    })
  ),
  dataMonthlyShare: PropTypes.arrayOf(dataDailyShareModel),
  onFilterDate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOnErrorLoadData: PropTypes.bool.isRequired,
  initialDate: PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    weekday: PropTypes.string
  }).isRequired
};

export default Audiences;
